import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { compose } from 'recompose';
import PropTypes from 'prop-types';
import cx from 'classnames';

import { readCookie, createCookie } from '../../utils/cookie';
import { getCookieConsent } from '../../reducers/portalConfig';
import styles from './styles';

import base64 from 'base-64';
import sanitizeHtml from 'sanitize-html';
import utf8 from 'utf8';
import CookiePreviewBanner from '../CookiePreviewBanner';
import { withStyles } from '@material-ui/core';

export const getDecodedSanitizedConsentMessage = (message) => {
  const text = utf8.decode(base64.decode(message));
  return sanitizeHtml(
    text,
    {
      allowedTags: ['p', 'strong', 'a', 'span'],
      allowedAttributes: {
        'a': ['href', 'target', 'style'],
        'p': ['style'],
        'strong': ['style'],
        'span': ['style'],
      },
      allowedStyles: {
        '*': {
          'color': [/^#(0x)?[0-9a-f]+$/i, /^rgb\(\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*(\d{1,3})\s*\)$/],
          'text-align': [/^left$/, /^right$/, /^center$/],
          'font-size': [/^\d+(?:px|em|%)$/],
        },
      },
    },
  );
};

const CookiePolicyBanner = (props) => {
  const { classes, cookieConsent } = props;
  const [state, setState] = useState({
    open: false,
    vertical: 'top',
    horizontal: 'center',
    root: classes.rootDark,
    content: '',
  });

  const handleClose = () => {
    setState({ ...state, open: false });
    const cookie = readCookie('cpb');
    if (cookie === null || cookie.toLowerCase() === 'true') {
      createCookie('cpb', 'false', 365, '/');
    }
  };

  useEffect(() => {
    if (cookieConsent) {
      const rootThemeClass = (cookieConsent.theme === 'light' ? classes.rootLight : classes.rootDark);
      const rootPositionClass = (cookieConsent.position === 'top' ? classes.rootTop : classes.rootBottom);
      const contentText = getDecodedSanitizedConsentMessage(cookieConsent.message);
      const cookie = readCookie('cpb');
      if (!cookie || (cookie.toLowerCase() === 'true')) {
        setState({
          ...state,
          root: cx(classes.root, rootThemeClass, rootPositionClass),
          content: contentText,
          vertical: cookieConsent.position,
          open: cookieConsent.enabled,
        });
      }
    }
  }, [cookieConsent]);

  return (
    <CookiePreviewBanner
      handleClose={handleClose}
      vertical={state.vertical}
      horizontal={state.horizontal}
      open={state.open}
      root={state.root}
      content={state.content}
    />
  );
};


const mapStateToProps = state => ({
  cookieConsent: getCookieConsent(state),
});

CookiePolicyBanner.propTypes = {
  classes: PropTypes.object,
  cookieConsent: PropTypes.object,
};

export default compose(
  withStyles(styles),
  connect(mapStateToProps, {}),
)(CookiePolicyBanner);

